module.exports = __webpack_public_path__ + "img/ISO27001-ISO27701-certificate-logo.9ead0991.png";